module.exports = __webpack_public_path__ + "static/online_treatment_1-93e5ca2086acb542280f2a06f624e680.png";